<!--
  --
  -- 免許証情報のサマリ コンポーネント
  --
  -->
<template>
  <c-summary-sheet>
    <template #title>免許証情報</template>

    <template>
      <!-- 有効期限 -->
      <c-summary-item>
        <template #caption>有効期限</template>
        <template #value>{{license.expire | timeformat('Y (JK) 年 m 月 d 日')}}</template>
      </c-summary-item>

      <!-- 免許証番号 -->
      <c-summary-item>
        <template #caption>免許証番号</template>
        <template #value>{{license.number}}</template>
      </c-summary-item>

      <!-- 免許取得日 -->
      <c-summary-item>
        <template #caption>免許取得日</template>
        <template #value>{{license.acquire | timeformat('Y (JK) 年 m 月 d 日')}}</template>
      </c-summary-item>

      <!-- 免許の種類 -->
      <c-summary-item>
        <template #caption>免許の種類</template>
        <template #value>{{license.types | licenseTypeText}}</template>
      </c-summary-item>

    </template>
  </c-summary-sheet>
</template>

<script>
import CSummarySheet from './CSummarySheet'
import CSummaryItem from './CSummaryItem'

export default {
  name: 'CSummaryLicense',
  components: {
    CSummarySheet,
    CSummaryItem
  },

  props: {
    license: {
      type: Object,
      required: true
    }
  },
  filters: {
    licenseTypeText (value) {
      const s = value || ''

      // 1 がついている要素名を列挙する
      const limited = LIMITED_ITEMS.reduce((items, item) => {
        if (s.charAt(item.value) === '1') {
          items.push(item.label)
        }
        return items
      }, [])
      const types = TYPE_ITEMS.reduce((items, item) => {
        if (s.charAt(item.value) === '1') {
          items.push(item.label)
        }
        return items
      }, [])

      // テキストを整形する
      let text = ''
      if (types.length > 0) {
        text += types.join(', ')
      }
      if (types.length > 0 && limited.length > 0) {
        text += ' / '
      }
      if (limited.length > 0) {
        text += limited.join(', ')
      }
      return text
    }
  }
}

const LIMITED_ITEMS = [
  { label: 'ＡＴ限定', value: 14 },
  { label: '８ｔ限定', value: 15 },
  { label: '５ｔ限定', value: 16 }
]

const TYPE_ITEMS = [
  { label: '大型', value: 0 },
  { label: '中型', value: 1 },
  { label: '準中型', value: 2 },
  { label: '普通', value: 3 },
  { label: '大型特殊', value: 4 },
  { label: '大自ニ輪', value: 5 },
  { label: '普自ニ輪', value: 6 },
  { label: '小型特殊', value: 7 },
  { label: '原付', value: 8 },
  { label: '大型ニ種', value: 9 },
  { label: '中型ニ種', value: 10 },
  { label: '普通ニ種', value: 11 },
  { label: '大特ニ種', value: 12 },
  { label: 'けん引', value: 13 }
]
</script>
